import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation, Link, Navigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Wallet, BookOpen, MessageSquare, Bell, LogOut, Menu, X, Sparkles, FileText, GraduationCap, BarChart3, ShoppingBag, AlertCircle, Settings, ClipboardList, Calendar, Trophy, Package, Boxes, Shield, Coins, Scale, Banknote, Layers, Heart, UtensilsCrossed, Briefcase, ShieldAlert, Clock, UserX, Receipt, Star, UserPlus, Percent, CreditCard, CalendarDays, ScanLine, DoorOpen, Radio, FileWarning, Library, DatabaseBackup, Download
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { ASSETS, SCHOOL_INFO } from "@/lib/assets";
import AIWidget from "./AIWidget";
import WhatsAppButton from "./WhatsAppButton";
import { ForcePasswordChange } from "./ForcePasswordChange";

const NAV_BY_ROLE = {
  scolarite: [
    { to: "/dashboard/scolarite", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/dashboard/scolarite/inscriptions", label: "Inscriptions", icon: UserPlus },
    { to: "/dashboard/scolarite/dossiers", label: "Dossiers élèves", icon: FileText },
    { to: "/dashboard/affectations", label: "Affectations profs", icon: Users },
    { to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
    { to: "/dashboard/notes-classe", label: "Notes des classes", icon: BookOpen },
    { to: "/dashboard/scolarite/plans", label: "Plans de paiement", icon: Wallet },
    { to: "/dashboard/scolarite/remises", label: "Remises", icon: Percent },
    { to: "/dashboard/scolarite/encaisser", label: "Caisse (encaisser)", icon: Banknote },
    { to: "/dashboard/scolarite/frais", label: "Grille des frais", icon: Briefcase },
    { to: "/dashboard/messages", label: "Messages", icon: MessageSquare },
    { to: "/dashboard/cartes", label: "Cartes & badges", icon: CreditCard },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/presence", label: "Présence temps réel", icon: Radio },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
  ],
  super_admin: [
    { to: "/dashboard", label: "Vue d'ensemble", icon: LayoutDashboard, end: true },
    { to: "/dashboard/scolarite/frais", label: "Grille des frais (paramétrer)", icon: Briefcase },
    { to: "/dashboard/scolarite", label: "Vue Scolarité", icon: GraduationCap },
    { to: "/dashboard/registre-inscrits", label: "Registre des inscrits", icon: Users },
    { to: "/dashboard/parametres-ecole", label: "Config école (logo)", icon: Settings },
    { to: "/dashboard/ouverture-annee", label: "Ouverture année scolaire", icon: CalendarDays },
    { to: "/dashboard/bi", label: "BI Décisionnel", icon: BarChart3 },
    { to: "/dashboard/etats-service", label: "États de service", icon: ClipboardList },
    { to: "/dashboard/audit", label: "Journal d'audit", icon: Shield },
    { to: "/dashboard/sauvegardes", label: "Sauvegardes", icon: DatabaseBackup },
    { to: "/dashboard/utilisateurs", label: "Utilisateurs & rôles", icon: Shield },
    { to: "/dashboard/organigramme", label: "Organigramme", icon: Layers },
    { to: "/dashboard/contenu-site", label: "Contenu du site", icon: ShoppingBag },
    { to: "/dashboard/tableau-honneur", label: "Tableau d'honneur", icon: Trophy },
    { to: "/dashboard/inscriptions", label: "Inscriptions", icon: FileText },
    { to: "/dashboard/eleves", label: "Élèves", icon: GraduationCap },
    { to: "/dashboard/scolarite/dossiers", label: "Dossiers élèves", icon: FileText },
    { to: "/dashboard/rh/candidatures", label: "Recrutement", icon: Briefcase },
    { to: "/dashboard/affectations", label: "Affectations profs", icon: Users },
    { to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
    { to: "/dashboard/notes-classe", label: "Notes des classes", icon: BookOpen },
    { to: "/dashboard/reajustements", label: "Réajustements notes", icon: FileText },
    { to: "/dashboard/paie", label: "Paie", icon: Coins },
    { to: "/dashboard/finance", label: "Finance", icon: Wallet },
    { to: "/dashboard/comptabilite", label: "Comptabilité", icon: BookOpen },
    { to: "/dashboard/infirmerie", label: "Infirmerie", icon: Heart },
    { to: "/dashboard/cantine", label: "Cantine", icon: UtensilsCrossed },
    { to: "/dashboard/ia-pedagogique", label: "IA Pédagogique", icon: Sparkles },
    { to: "/dashboard/signalements", label: "Signalements", icon: ShieldAlert },
    { to: "/dashboard/evaluations", label: "Évals enseignants", icon: Star },
    { to: "/dashboard/absences", label: "Absences employés", icon: UserX },
    { to: "/dashboard/promotions", label: "Promotions de classe", icon: GraduationCap },
    { to: "/dashboard/ia-inactivite", label: "Élèves inactifs IA", icon: AlertCircle },
    { to: "/dashboard/paie/auto-pointage", label: "Paie auto (pointage)", icon: Coins },
    { to: "/dashboard/validation-recus", label: "Reçus à valider", icon: Receipt },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: Clock },
    { to: "/dashboard/scolarite", label: "Scolarité", icon: GraduationCap },
    { to: "/dashboard/ecole/parametres", label: "🏫 Config école", icon: Settings },
    { to: "/dashboard/cartes", label: "Cartes & badges", icon: CreditCard },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/presence", label: "Présence temps réel", icon: Radio },
    { to: "/dashboard/corrections", label: "Corrections pointage", icon: FileWarning },
    { to: "/dashboard/pointages-stats", label: "Statistiques pointage", icon: BarChart3 },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/production-reset", label: "⚠️ Reset & Mot de passe", icon: ShieldAlert },
    { to: "/dashboard/annonces", label: "Annonces", icon: Bell },
  ],
  founder: [
    { to: "/dashboard/bi", label: "BI Décisionnel", icon: BarChart3 },
    { to: "/dashboard/registre-inscrits", label: "Registre des inscrits", icon: Users },
    { to: "/dashboard", label: "Aperçu", icon: LayoutDashboard, end: true },
    { to: "/dashboard/finance", label: "Finance globale", icon: Wallet },
    { to: "/dashboard/comptabilite", label: "Comptabilité", icon: BookOpen },
    { to: "/dashboard/paie", label: "Paie", icon: Coins },
    { to: "/dashboard/etats-service", label: "États de service", icon: ClipboardList },
    { to: "/dashboard/rh/candidatures", label: "Recrutement", icon: Briefcase },
    { to: "/dashboard/audit", label: "Journal d'audit", icon: Shield },
    { to: "/dashboard/sauvegardes", label: "Sauvegardes", icon: DatabaseBackup },
    { to: "/dashboard/scolarite/frais", label: "Valider grilles frais", icon: Briefcase },
    { to: "/dashboard/scolarite/remises", label: "Valider remises", icon: Percent },
    { to: "/dashboard/signalements", label: "Signalements", icon: ShieldAlert },
    { to: "/dashboard/evaluations", label: "Évals enseignants", icon: Star },
    { to: "/dashboard/absences", label: "Absences RH", icon: UserX },
    { to: "/dashboard/promotions", label: "Promotions de classe", icon: GraduationCap },
    { to: "/dashboard/ia-inactivite", label: "Élèves inactifs IA", icon: AlertCircle },
    { to: "/dashboard/paie/auto-pointage", label: "Paie auto (pointage)", icon: Coins },
    { to: "/dashboard/cartes", label: "Cartes & badges", icon: CreditCard },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/presence", label: "Présence temps réel", icon: Radio },
    { to: "/dashboard/corrections", label: "Corrections pointage", icon: FileWarning },
    { to: "/dashboard/pointages-stats", label: "Statistiques pointage", icon: BarChart3 },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/infirmerie", label: "Infirmerie", icon: Heart },
    { to: "/dashboard/cantine", label: "Cantine", icon: UtensilsCrossed },
    { to: "/dashboard/inscriptions", label: "Inscriptions", icon: FileText },
    { to: "/dashboard/scolarite/dossiers", label: "Dossiers élèves", icon: FileText },
    { to: "/dashboard/ia-pedagogique", label: "IA Pédagogique", icon: Sparkles },
    { to: "/dashboard/classements", label: "Classements", icon: Trophy },
    { to: "/dashboard/annonces", label: "Communications", icon: Bell },
  ],
  director: [
    { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/dashboard/inscriptions", label: "Inscriptions", icon: FileText },
    { to: "/dashboard/eleves", label: "Élèves", icon: GraduationCap },
    { to: "/dashboard/scolarite/dossiers", label: "Dossiers élèves", icon: FileText },
    { to: "/dashboard/affectations", label: "Affectations profs", icon: Users },
    { to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
    { to: "/dashboard/notes-classe", label: "Notes des classes", icon: BookOpen },
    { to: "/dashboard/reajustements", label: "Réajustements notes", icon: FileText },
    { to: "/dashboard/evaluations", label: "Évals enseignants", icon: Star },
    { to: "/dashboard/signalements", label: "Signalements", icon: ShieldAlert },
    { to: "/dashboard/absences", label: "Absences employés", icon: UserX },
    { to: "/dashboard/validation-recus", label: "Valider reçus", icon: Receipt },
    { to: "/dashboard/promotions", label: "Promotions de classe", icon: GraduationCap },
    { to: "/dashboard/ia-inactivite", label: "Élèves inactifs IA", icon: AlertCircle },
    { to: "/dashboard/annonces", label: "Annonces", icon: Bell },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: Clock },
    { to: "/dashboard/cartes", label: "Cartes & badges", icon: CreditCard },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/presence", label: "Présence temps réel", icon: Radio },
    { to: "/dashboard/corrections", label: "Corrections pointage", icon: FileWarning },
    { to: "/dashboard/pointages-stats", label: "Statistiques pointage", icon: BarChart3 },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
  ],
  finance: [
    { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/dashboard/finance", label: "Paiements scolarité", icon: Wallet },
    { to: "/dashboard/commandes", label: "Commandes", icon: Package },
    { to: "/dashboard/comptabilite", label: "Comptabilité", icon: BookOpen, section: "Comptabilité — SYSCOHADA" },
    { to: "/dashboard/comptabilite/saisies", label: "Saisies", icon: FileText },
    { to: "/dashboard/comptabilite/journaux", label: "Journaux", icon: Layers },
    { to: "/dashboard/comptabilite/balance", label: "Balance générale", icon: Scale },
    { to: "/dashboard/comptabilite/exploitation", label: "Compte d'exploitation", icon: Coins },
    { to: "/dashboard/comptabilite/tresorerie", label: "Trésorerie", icon: Banknote },
    { to: "/dashboard/comptabilite/plan-comptable", label: "Plan comptable", icon: BookOpen },
    { to: "/dashboard/paie/auto-pointage", label: "Paie auto (pointage)", icon: Coins },
    { to: "/dashboard/validation-recus", label: "Reçus bancaires", icon: Receipt },
    { to: "/dashboard/reclamations", label: "Réclamations financières", icon: AlertCircle },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: Clock },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  admin: [
    { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/dashboard/utilisateurs", label: "Utilisateurs & rôles", icon: Shield },
    { to: "/dashboard/organigramme", label: "Organigramme", icon: Layers },
    { to: "/dashboard/contenu-site", label: "Contenu du site", icon: ShoppingBag },
    { to: "/dashboard/tableau-honneur", label: "Tableau d'honneur", icon: Trophy },
    { to: "/dashboard/inscriptions", label: "Inscriptions", icon: FileText },
    { to: "/dashboard/eleves", label: "Élèves", icon: GraduationCap },
    { to: "/dashboard/scolarite/dossiers", label: "Dossiers élèves", icon: FileText },
    { to: "/dashboard/rh/candidatures", label: "Recrutement", icon: Briefcase },
    { to: "/dashboard/affectations", label: "Affectations profs", icon: Users },
    { to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
    { to: "/dashboard/notes-classe", label: "Notes des classes", icon: BookOpen },
    { to: "/dashboard/reajustements", label: "Réajustements notes", icon: FileText },
    { to: "/dashboard/paie", label: "Paie", icon: Wallet },
    { to: "/dashboard/absences", label: "Absences employés", icon: UserX },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: Clock },
    { to: "/dashboard/validation-recus", label: "Valider reçus", icon: Receipt },
    { to: "/dashboard/infirmerie", label: "Infirmerie", icon: Heart },
    { to: "/dashboard/cantine", label: "Cantine", icon: UtensilsCrossed },
    { to: "/dashboard/commandes", label: "Commandes manuels", icon: Package },
    { to: "/dashboard/stock", label: "Stock manuels", icon: Boxes },
    { to: "/dashboard/annonces", label: "Annonces", icon: Bell },
    { to: "/dashboard/reclamations", label: "Réclamations", icon: AlertCircle },
    { to: "/dashboard/cartes", label: "Cartes & badges", icon: CreditCard },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/presence", label: "Présence temps réel", icon: Radio },
    { to: "/dashboard/corrections", label: "Corrections pointage", icon: FileWarning },
    { to: "/dashboard/pointages-stats", label: "Statistiques pointage", icon: BarChart3 },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  teacher: [
    { to: "/dashboard", label: "Mes classes", icon: LayoutDashboard, end: true },
    { to: "/dashboard/mes-eleves", label: "Mes élèves", icon: Users },
    { to: "/dashboard/notes-classe", label: "Notes de mes classes", icon: BookOpen },
    { to: "/dashboard/cours", label: "Bibliothèque cours", icon: BookOpen },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque numérique", icon: Library },
    { to: "/dashboard/coin-lecture", label: "Coin lecture (objectifs)", icon: BookOpen },
    { to: "/dashboard/devoirs", label: "Devoirs & contrôles", icon: ClipboardList },
    { to: "/dashboard/saisie-notes", label: "Saisie des notes", icon: FileText },
    { to: "/dashboard/presences", label: "Présences / Appel", icon: Calendar },
    { to: "/dashboard/emploi-du-temps", label: "Emploi du temps", icon: CalendarDays },
    { to: "/dashboard/classements", label: "Classements", icon: Trophy },
    { to: "/dashboard/tableau-honneur", label: "Tableau d'honneur", icon: Trophy },
    { to: "/dashboard/reclamations", label: "Réclamations pédago.", icon: AlertCircle },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: Clock },
    { to: "/dashboard/corrections", label: "Mes anomalies", icon: FileWarning },
    { to: "/dashboard/ia-pedagogique", label: "IA — Quiz & Analyse", icon: Sparkles },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  parent: [
    { to: "/dashboard", label: "Mon tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/dashboard/enfants", label: "Mes enfants", icon: Users },
    { to: "/dashboard/entrees-sorties", label: "Entrées & sorties", icon: DoorOpen },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque numérique", icon: Library },
    { to: "/dashboard/notes", label: "Notes & bulletins", icon: BookOpen },
    { to: "/dashboard/emploi-du-temps", label: "Emplois du temps", icon: CalendarDays },
    { to: "/dashboard/paiements", label: "Paiements", icon: Wallet },
    { to: "/dashboard/mes-recus", label: "Reçus bancaires", icon: Receipt },
    { to: "/dashboard/signaler", label: "Signaler anonymement", icon: ShieldAlert },
    { to: "/dashboard/reclamations", label: "Réclamations", icon: AlertCircle },
    { to: "/dashboard/manuels", label: "Boutique manuels", icon: ShoppingBag },
    { to: "/dashboard/commandes", label: "Mes commandes", icon: Package },
    { to: "/dashboard/messages", label: "Messages", icon: MessageSquare },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  student: [
    { to: "/dashboard/mon-espace", label: "Mon espace", icon: LayoutDashboard },
    { to: "/dashboard", label: "Accueil", icon: LayoutDashboard, end: true },
    { to: "/dashboard/cours", label: "Mes cours", icon: BookOpen },
    { to: "/dashboard/devoirs", label: "Devoirs & contrôles", icon: ClipboardList },
    { to: "/dashboard/emploi-du-temps", label: "Emploi du temps", icon: CalendarDays },
    { to: "/dashboard/entrees-sorties", label: "Entrées & sorties", icon: DoorOpen },
    { to: "/dashboard/bibliotheque", label: "Bibliothèque numérique", icon: Library },
    { to: "/dashboard/coin-lecture", label: "Coin lecture", icon: BookOpen },
    { to: "/dashboard/quiz-ia", label: "Sujets IA (quiz)", icon: Sparkles },
    { to: "/dashboard/notes", label: "Mes notes", icon: Trophy },
    { to: "/dashboard/evaluer-enseignants", label: "Évaluer mes profs", icon: Star },
    { to: "/dashboard/signaler", label: "Signaler anonymement", icon: ShieldAlert },
    { to: "/dashboard/paiements", label: "Paiements", icon: Wallet },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  staff: [
    { to: "/dashboard", label: "Accueil", icon: LayoutDashboard, end: true },
    { to: "/dashboard/annonces", label: "Annonces", icon: FileText },
    { to: "/dashboard/messages", label: "Messages", icon: FileText },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: ClipboardList },
    { to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
  nurse: [
    { to: "/dashboard", label: "Accueil", icon: LayoutDashboard, end: true },
    { to: "/dashboard/infirmerie", label: "Infirmerie", icon: LayoutDashboard },
    { to: "/dashboard/infirmerie/passages", label: "Passages", icon: ClipboardList },
    { to: "/dashboard/infirmerie/fiches", label: "Fiches santé", icon: FileText },
    { to: "/dashboard/infirmerie/pharmacie", label: "Pharmacie", icon: ClipboardList },
    { to: "/dashboard/annonces", label: "Annonces", icon: FileText },
    { to: "/dashboard/pointage", label: "Mon pointage", icon: ClipboardList },
    { to: "/dashboard/manuel", label: "📘 Manuel utilisateur", icon: FileText },
    { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles },
  ],
};

const STAFF_ROLES = ["super_admin", "admin", "founder", "finance", "teacher", "scolarite", "director", "nurse", "canteen", "staff"];

// Navigation dynamique pilotée par les habilitations RBAC (postes personnalisés)
const PERM_NAV = [
  { perm: "teachers.assign", to: "/dashboard/affectations", label: "Affectations profs", icon: Users },
  { perm: "subjects.manage", to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
  { perm: "classes.manage", to: "/dashboard/parametres-pedagogiques", label: "Matières & classes", icon: BookOpen },
  { perm: "grades.view_all", to: "/dashboard/notes-classe", label: "Notes des classes", icon: BookOpen },
  { perm: "grades.adjust.approve", to: "/dashboard/reajustements", label: "Réajustements notes", icon: FileText },
  { perm: "expenses.create", to: "/dashboard/depenses", label: "Sorties d'argent", icon: Coins },
  { perm: "expenses.approve", to: "/dashboard/depenses", label: "Sorties d'argent", icon: Coins },
  { perm: "postes.manage", to: "/dashboard/postes", label: "Postes & habilitations", icon: ShieldAlert },
  { perm: "stats.view", to: "/dashboard/bi", label: "BI Décisionnel", icon: BarChart3 },
  { perm: "users.manage", to: "/dashboard/utilisateurs", label: "Utilisateurs & rôles", icon: Users },
  { perm: "timetable.manage", to: "/dashboard/emploi-du-temps", label: "Emplois du temps", icon: CalendarDays },
  { perm: "gate.scan", to: "/dashboard/portail", label: "Portail entrées/sorties", icon: ScanLine },
  { perm: "library.manage", to: "/dashboard/bibliotheque", label: "Bibliothèque", icon: Library },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [perms, setPerms] = useState([]);

  useEffect(() => {
    if (user && STAFF_ROLES.includes(user.role)) {
      api.get("/rbac/my-permissions").then(r => setPerms(r.data.permissions || [])).catch(() => {});
    }
  }, [user?.id]);

  if (!user) {
    const loginPath = localStorage.getItem("mazid_portal") === "admin" ? "/admin-portal" : "/connexion";
    return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
  }

  // Changement de mot de passe obligatoire (ex : élève créé avec matricule)
  if (user.must_change_password) {
    return <ForcePasswordChange />;
  }

  // Rôle inconnu (poste personnalisé) → navigation Personnel, jamais le portail Parent
  const baseNav = NAV_BY_ROLE[user.role] || (user.role === "parent" ? NAV_BY_ROLE.parent : NAV_BY_ROLE.staff);
  // Ajout des entrées issues des habilitations (postes personnalisés), sans doublon
  const seen = new Set(baseNav.map(i => i.to + i.label));
  const extra = [];
  for (const item of PERM_NAV) {
    if (perms.includes(item.perm) && !seen.has(item.to + item.label)) {
      seen.add(item.to + item.label);
      extra.push(item);
    }
  }
  const nav = [...baseNav, ...extra];

  const isActive = (to, end) => end ? location.pathname === to : location.pathname.startsWith(to);

  const handleLogout = () => {
    const marker = localStorage.getItem("mazid_portal");
    const isStaff = marker ? marker === "admin" : STAFF_ROLES.includes(user.role);
    navigate(isStaff ? "/admin-portal" : "/connexion", { replace: true });
    logout();
  };

  const roleLabel = ({
    super_admin: "Super Administrateur", founder: "Fondateur", finance: "Service Financier",
    admin: "Administration", teacher: "Enseignant·e", parent: "Parent", student: "Élève",
    staff: "Personnel", nurse: "Infirmerie", scolarite: "Scolarité", director: "Direction Générale",
  })[user.role] || user.role;

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]" data-testid="dashboard-layout">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-72 bg-[#1E3A8A] text-white transform transition-transform ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 flex flex-col`} data-testid="dashboard-sidebar">
        <div className="px-6 py-6 border-b border-white/10">
          <Link to="/" className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="Logo Mazid" className="h-12 w-12 rounded-xl object-contain bg-white p-0.5 ring-2 ring-[#FBBF24]/40" />
            <div>
              <div className="font-heading font-extrabold text-base leading-none">MAZID</div>
              <div className="text-[10px] tracking-[0.25em] text-[#FBBF24] mt-1 uppercase">School Connect</div>
            </div>
          </Link>
        </div>

        <nav className="flex-1 px-4 py-5 space-y-1 overflow-y-auto">
          {nav.map((n, i) => (
            <Link
              key={i}
              to={n.to}
              onClick={() => setOpen(false)}
              className={`sidebar-item ${isActive(n.to, n.end) ? "active" : ""}`}
              data-testid={`sidebar-link-${n.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
            >
              <n.icon className="h-4 w-4" />
              <span>{n.label}</span>
            </Link>
          ))}
        </nav>

        <div className="px-4 py-4 border-t border-white/10">
          <div className="flex items-center gap-3 px-3 py-2 mb-2">
            <div className="w-9 h-9 rounded-full bg-[#166534] text-white flex items-center justify-center text-sm font-bold">
              {user.full_name?.split(" ").map(n => n[0]).slice(0, 2).join("")}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{user.full_name}</div>
              <div className="text-[10px] uppercase tracking-wider text-[#FBBF24] truncate">{roleLabel}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="sidebar-item w-full" data-testid="logout-btn">
            <LogOut className="h-4 w-4" />
            <span>Déconnexion</span>
          </button>
          <button
            onClick={async () => {
              try {
                const { api } = await import("@/lib/api");
                const resp = await api.get("/manual/download", { responseType: "blob" });
                const blob = new Blob([resp.data], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Manuel_MAZID.pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
              } catch (e) {
                console.error("Manual download failed", e);
              }
            }}
            className="sidebar-item w-full mt-2 text-xs opacity-80 hover:opacity-100"
            data-testid="download-manual-btn"
          >
            <FileText className="h-4 w-4" />
            <span>Mon manuel PDF</span>
          </button>
          <Link
            to="/dashboard/installer"
            onClick={() => setOpen(false)}
            className="sidebar-item w-full mt-2 text-xs opacity-80 hover:opacity-100"
            data-testid="install-app-link"
          >
            <Download className="h-4 w-4" />
            <span>Installer l&apos;application</span>
          </Link>
        </div>
      </aside>

      {open && <div className="fixed inset-0 bg-black/50 z-30 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-slate-200 px-5 lg:px-8 py-4 flex items-center justify-between sticky top-0 z-20">
          <button onClick={() => setOpen(true)} className="lg:hidden p-2 rounded-md border border-slate-200" data-testid="sidebar-toggle">
            <Menu className="h-5 w-5" />
          </button>
          <div className="flex-1 lg:ml-0 ml-3">
            <h1 className="font-heading font-bold text-lg text-[#1E3A8A] truncate">
              Espace {roleLabel}
            </h1>
            <p className="text-xs text-slate-500 hidden sm:block">Bienvenue, {user.full_name}</p>
          </div>
        </header>

        <main className="flex-1 p-5 lg:p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      <AIWidget />
      <WhatsAppButton variant="floating" testId="whatsapp-float-dashboard" />
    </div>
  );
}
